import {ModelInterface} from "../../../data-structures/collection";
import {AIChatProvider, AiChatType} from "../@const";
import DatetimeUtils from "../../../gd/utils/datetime-utils";
import AIChatContext from "./context/context";


export default class AIChat implements ModelInterface {

    public id               : ID
    public name             : string
    public firstMessage     : string
    public botId            : ID
    public companyId        : ID
    public context          : AIChatContext
    public isDeleted        : boolean
    public metadata         : any       // ????
    public momentCreated    : Moment

    public provider         : AIChatProvider
    public type             : AiChatType
    public userId           : ID
    public agentId          : ID | null



    constructor(data: any) {

        this.id             = _.get(data, 'id', null)
        this.name           = _.get(data, 'name', "")
        this.firstMessage   = _.get(data, 'firstMessage', "")
        this.botId          = _.get(data, 'botId', null)
        this.companyId      = _.get(data, 'companyId', null)
        this.context        = new AIChatContext(data?.context || {})
        this.isDeleted      = _.get(data, 'isDeleted', false)
        this.metadata       = _.get(data, 'metadata', null)
        this.momentCreated  = DatetimeUtils.datetimeToMoment(data?.momentCreated)
        this.provider       = _.get(data, 'provider', AIChatProvider.GPT_4o_MINI)
        this.type           = _.get(data, 'type', AiChatType.CHAT)
        this.userId         = _.get(data, 'userId', null)
        this.agentId        = _.get(data, 'agentId', null)

    }


    toJSON() {

        return {
            id              : this.id,
            name            : this.name,
            firstMessage    : this.firstMessage,
            botId           : this.botId,
            companyId       : this.companyId,
            context         : this.context,
            isDeleted       : this.isDeleted,
            metadata        : this.metadata,
            momentCreated   : this.momentCreated.toJSON(),
            provider        : this.provider,
            type            : this.type,
            userId          : this.userId,
            agentId         : this.agentId,
        }
    }
}
